import { styled, Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CommonUtil from "../../Util/CommonUtils";
import info from "../../assets/USA_Images/InfoIcon.svg";
import infoLight from "../../assets/USA_Images/InfoIconLight.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  addHealthQuestionarie,
  updateHealthQuestionarie,
} from "../../slices/HealthQuestionaries/HealthQuestionariesSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#36C96D0D",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #007CE8",
    marginRight: "250px",
  },
}));

export default function AddHealthQuestionaries(props) {
  const { open, handleClose } = props;
  const [selectedObject, setSelectedObject] = React.useState(
    props.selectedObject
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [str, setStr] = useState("");
  const [iconHovered, setIconHovered] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const handleMouseEnter = () => setIconHovered(true);
  const handleMouseLeave = () => setIconHovered(false);

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]:
        name === "isMandatory" ? event.target.checked : event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      setState({
        ...state,
        options: state.options + " ",
      });
    } else if (event.key === "Backspace") {
      event.preventDefault();
      const options = state.options;
      if (options.length > 0) {
        setState({
          ...state,
          options: options.slice(0, -1),
        });
      }
    }
  };

  const [state, setState] = React.useState({
    question: "",
    options: [],
    expertedAnswer: "",
    isMandatory: true,
    // isDisabled:false,
  });

  const [error, setError] = React.useState({
    question: false,
    options: false,
    expertedAnswer: false,
    isMandatory: false,
    // isDisabled:false
  });

  const handleSubmit = () => {
    if (state.question === "" || state.question === undefined) {
      setError({ question: "error" });
      Toast(t("CHECKLISTFORM001"), "error");
      return false;
    }

    if (/[,";'"]/.test(state.question)) {
      Toast(
        "Check list item cannot contain commas, semicolons, single quotes or double quotes",
        "error"
      );
      setError({ question: "error" });
      return false;
    }

    if (state.options === "" || state.options === undefined) {
      setError({ options: "error" });
      Toast(t("CHECKLISTFORM002"), "error");
      return false;
    }

    if (CommonUtil.isEmptyString(state.expertedAnswer)) {
      Toast(t("ENTER_EXPECTED_ANSWER"), "error");
      setError({ expertedAnswer: true });
      return false;
    }

    if (CommonUtil.isEmptyString(props.selectedObject.id)) {
      const newTemplate = {
        question: state.question,
        options: [state.options],
        expertedAnswer: state.expertedAnswer,
        mandatory: state.isMandatory ? "Yes" : "No",
        templateId: props.templateId,
        isDisabled: false,
      };

      dispatch(addHealthQuestionarie(newTemplate))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0055") {
            Toast(data.message, "success");
            handleClose();
          } else {
            Toast(data.message, "error");
          }
        });
    } else {
      const updateTemplate = {
        id: CommonUtil.isEmpty(props.selectedObject)
          ? null
          : props.selectedObject.id,
        question: state.question,
        options: [state.options],
        expertedAnswer: state.expertedAnswer,
        mandatory: state.isMandatory ? "Yes" : "No",
        templateId: props.templateId,
        isDisabled: false,
      };

      dispatch(updateHealthQuestionarie(updateTemplate))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0056") {
            Toast(data.message, "success");
            handleClose();
          } else {
            Toast(data.message, "error");
          }
        });
    }
  };

  useEffect(() => {
    if (props.selectedObject) {
      setState({
        ...state,
        id: props.selectedObject.id,
        question: props.selectedObject.question,
        options: props.selectedObject.options
          ? props.selectedObject.options[0]
          : "",
        //    options: props.selectedObject.options,
        expertedAnswer: props.selectedObject.expertedAnswer,
        isMandatory:
          props.selectedObject.mandatory === "Yes" ||
          props.selectedObject.mandatory === "yes",
      });
    }
  }, []);

  return (
    <>
      <Dialog
        open={open}
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
            overflowY: "hidden",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: 450,
            }}
          >
            {state.id ? t("EDIT_CHECKLIST") : t("CREATE_CHECKLIST")}
          </Typography>
        </DialogTitle>

        <Divider
          variant="middle"
          style={{
            background:
              "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent style={{ paddingBottom: "1px" }}>
          <Grid
            container
            justifyContent="center"
            rowSpacing={2}
            columnSpacing={1}
          >
            <Grid item xs={12}>
              <CustomTextfield
                type={"text"}
                label={t("tableColumnHeaderItem")}
                error={error.question}
                name="question"
                value={state.question}
                handleChange={(e) => handleChange(e)}
                required={true}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("slectLabeloptions")}
                error={error.options}
                name="options"
                value={state.options}
                onChange={(e) => handleChange(e)}
                onKeyDown={handleKeyDown}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              color="inherit"
                              style={{ color: darkMode ? "#fff" : "" }}
                            >
                              {t("CHECKLISTOPTIONSINFO001")}
                            </Typography>
                            <b style={{ color: darkMode ? "#fff" : "" }}>
                              {t("CHECKLISTOPTIONSINFO003") + ": "}
                            </b>{" "}
                            <em style={{ color: darkMode ? "#fff" : "" }}>
                              {t("CHECKLISTOPTIONSINFO002")}
                            </em>
                          </React.Fragment>
                        }
                      >
                        <IconButton
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          {darkMode ? (
                            <img
                              src={info}
                              alt="logo"
                              className="left_img"
                              height="24px"
                              width="24px"
                            />
                          ) : (
                            <img
                              src={infoLight}
                              alt="logo"
                              className="left_img"
                              height="24px"
                              width="24px"
                            />
                          )}
                        </IconButton>
                      </HtmlTooltip>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#a09e9e !important",
                  },
                  "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root:hover": {
                    color: darkMode ? "#ffffff !important" : "black",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: darkMode ? "#f8f9ff" : "black",
                    "& fieldset": {
                      borderColor: darkMode ? "#777" : "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: darkMode ? "#ffffff" : "#a09e9e !important",
                    },
                  },
                }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xs={12}>
              <CustomTextfield
                type="text"
                label={t("EXPECTED_ANSWER")}
                error={error.expertedAnswer}
                name="expertedAnswer"
                value={state.expertedAnswer}
                handleChange={(e) => handleChange(e)}
                required
              />
            </Grid>

            <Grid item xs={12} style={{ bottom: "12px", right: "1px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.isMandatory}
                    style={{ color: process.env.REACT_APP_BG_ICON }}
                    onChange={handleChange}
                    name="isMandatory"
                  />
                }
                label={
                  <span style={{ color: darkMode ? "#fff" : "" }}>
                    {t("CHECKLISTFORM006")}
                  </span>
                }
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          style={{
            justifyContent: "center",
            marginTop: "-30px",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={handleClose}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>

          <SubmitButtons variant="contained" onClick={handleSubmit}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
